document.addEventListener('DOMContentLoaded', function() {

  /* ── Mobile nav ── */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function() {
      mobileNav.classList.toggle('open');
      this.setAttribute('aria-expanded', mobileNav.classList.contains('open'));
    });
    document.addEventListener('click', function(e) {
      if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── Product image gallery ── */
  var mainImg   = document.getElementById('pdp-main-img') || document.querySelector('.pdp-main-img img');
  var mainFrame = document.querySelector('.pdp-main-img');
  var thumbs    = document.querySelectorAll('.pdp-thumb');

  function swapImage(thumb) {
    /* Get full-size URL from data-src attribute */
    var newSrc = thumb.getAttribute('data-src');

    /* Fallback: grab src from the img inside the thumb, upgrade to larger size */
    if (!newSrc) {
      var thumbImg = thumb.querySelector('img');
      if (thumbImg) {
        newSrc = thumbImg.getAttribute('src') || thumbImg.src;
        /* Try to upgrade to a larger Shopify image size */
        newSrc = newSrc.replace(/_(\d+)x(\d+)/, '_1200x1200');
      }
    }

    if (!newSrc || !mainImg) return;

    /* Fade out → swap → fade in */
    mainImg.style.opacity = '0.4';
    mainImg.style.transition = 'opacity 0.12s';

    var newImage = new Image();
    newImage.onload = function() {
      mainImg.src = newSrc;
      mainImg.style.opacity = '1';
    };
    newImage.onerror = function() {
      /* If load fails, swap anyway */
      mainImg.src = newSrc;
      mainImg.style.opacity = '1';
    };
    newImage.src = newSrc;

    /* Failsafe — restore opacity after 400ms regardless */
    setTimeout(function() { mainImg.style.opacity = '1'; }, 400);

    /* Active state on thumbnails */
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  }

  /* Wire up click AND hover on every thumbnail */
  thumbs.forEach(function(thumb) {
    thumb.style.cursor = 'pointer';
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      swapImage(this);
    });
    thumb.addEventListener('mouseenter', function() {
      swapImage(this);
    });
  });

  /* ── Zoom on main image hover ── */
  if (mainFrame && mainImg) {
    mainFrame.style.overflow = 'hidden';
    mainFrame.style.cursor = 'zoom-in';
    mainImg.style.transition = 'transform 0.4s ease, opacity 0.12s';
    mainFrame.addEventListener('mouseenter', function() {
      mainImg.style.transform = 'scale(1.07)';
    });
    mainFrame.addEventListener('mouseleave', function() {
      mainImg.style.transform = 'scale(1)';
    });
    mainFrame.addEventListener('click', function() {
      if (mainImg.src) window.open(mainImg.src, '_blank');
    });
  }

  /* ── Purchase option selector ── */
  document.querySelectorAll('.purchase-opt').forEach(function(opt) {
    opt.addEventListener('click', function() {
      document.querySelectorAll('.purchase-opt').forEach(function(o) { o.classList.remove('selected'); });
      this.classList.add('selected');
      var radio = this.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    });
  });

  /* ── Quantity controls ── */
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus  = document.querySelector('.qty-plus');
  var qtyVal   = document.querySelector('.qty-val');
  if (qtyMinus && qtyPlus && qtyVal) {
    qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyVal.textContent);
      if (v > 1) qtyVal.textContent = v - 1;
    });
    qtyPlus.addEventListener('click', function() {
      qtyVal.textContent = parseInt(qtyVal.textContent) + 1;
    });
  }

  /* ── Add to cart feedback ── */
  /* ATC button — let Shopify handle the form submit natively.
     We only add visual feedback AFTER the form submits. */
  var atcBtn = document.querySelector('.atc-btn');
  if (atcBtn) {
    atcBtn.closest('form') && atcBtn.closest('form').addEventListener('submit', function() {
      atcBtn.innerHTML = '&#10003; Added!';
      atcBtn.style.background = 'var(--green)';
      setTimeout(function() {
        atcBtn.innerHTML = atcBtn.dataset.orig || atcBtn.innerHTML;
        atcBtn.style.background = '';
      }, 2000);
    });
    /* Store original label */
    atcBtn.dataset.orig = atcBtn.innerHTML;
  }

  /* ── Collection filter tabs ── */
  document.querySelectorAll('.filter-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      document.querySelectorAll('.filter-tab').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ── Email form feedback ── */
  document.querySelectorAll('.email-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = this.querySelector('input[type="email"]');
      var btn   = this.querySelector('button[type="submit"]');
      if (input && btn) {
        btn.textContent = '✓ You\'re in!';
        btn.disabled = true;
        input.value = '';
      }
    });
  });

  /* ── Proof bar marquee clone ── */
  var proofTrack = document.querySelector('.proof-bar-track');
  if (proofTrack) {
    var inner = proofTrack.querySelector('.proof-bar-inner');
    if (inner) proofTrack.appendChild(inner.cloneNode(true));
  }

  /* ── Sticky ATC bar — appears when original ATC scrolls out of view ── */
  var stickyBar = document.querySelector('.sticky-atc-bar');
  var originalAtc = document.querySelector('.atc-btn');
  if (stickyBar && originalAtc) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
      });
    }, { threshold: 0 });
    observer.observe(originalAtc);
  }

});
